"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _lodash = _interopRequireDefault(require("lodash.times"));
var _styles = require("../OlapicSlider/styles");
var _calculatePosition = require("../OlapicSlider/utils/calculatePosition");
var _components = require("./components");
var _MediaItemSkeleton = require("./components/MediaItemSkeleton");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SliderSkeleton = ({
  animation = 'pulse',
  className,
  count = _constants.SKELETON_COUNT
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Root, {
    className: className,
    "data-testid": getTestId(_constants.SLIDER_SKELETON),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.HeaderSkeleton, {
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MediaItems, {
        scrollable: true,
        isShort: false,
        dir: "ltr",
        children: (0, _lodash.default)(count).map((_, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaItemSkeleton.MediaItemSkeleton
        // eslint-disable-next-line react/no-array-index-key -- No other option for passing data to key
        , {
          position: (0, _calculatePosition.calculatePosition)({
            totalItems: count,
            index
          }),
          animation: animation
        }, `${_MediaItemSkeleton.MEDIA_ITEM_SKELETON}-${index}`))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ViewAllWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ViewAllButtonSkeleton, {
        animation: animation
      })
    })]
  });
};
exports.SliderSkeleton = SliderSkeleton;
